import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CRUDTable from 'components/Table/CRUD';
import axios from 'axios';
import PageTitle from 'components/Title/Page';
import { columns } from './config';
import Card from 'components/Card';
import { toast } from 'react-toastify';
import { staffClient } from 'clients/staff';

export const CategoriesPage = () => {
    const [tableData, setTableData] = useState(null)
    const params = useParams()

    useEffect(() => {
        updateTableData()
    }, [])

    const updateTableData = async () => {
        const boardId = params.boardId;
        if (!boardId) {
            return
        }
        const ret = await staffClient.get(`/board/${boardId}`)
        console.log("updateTableData", ret)
        const categories = ret?.data?.categories
        if (!categories) {
            return
        }
        setTableData(categories)
    }

    const handleCreate = async (row) => {
        const body = {
            name: row.name,
            boardId: params.boardId
        }
        const ret = await staffClient.post('/category', body)
        console.log("handleCreate return", ret)
        updateTableData()
        toast.success('카테고리가 생성 되었습니다.');
        return true
    }

    const handleEdit = async (row) => {
        const body = {
            name: row.name,
        }
        const ret = await staffClient.patch(`/category/${row.id}`, body)
        console.log("handleEdit return", ret)
        updateTableData()
        toast.success('카테고리가 수정 되었습니다.');
        return true
    }

    const handleDelete = async (row) => {
        const ret = await staffClient.delete(`/category/${row.id}`)
        updateTableData();
        toast.success('카테고리가 삭제 되었습니다.');
        return true;
      };


    return (
        <Card>
            <div className='p-3'>
                <PageTitle>카테고리 관리</PageTitle>
                <CRUDTable
                    data={tableData}
                    columns={columns}
                    onCreate={handleCreate}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                />
            </div>
        </Card>
    );
};

export default CategoriesPage